import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { AxiosResponse } from "axios";
// import { AxiosResponse } from "axios";

export default {
    async list(param: types.ReqReportListForAdmin): Promise<types.ResPaging> {
        const res = {} as types.ResPaging;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/report/list", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async detail(searchType: number, type: number, idx: number): Promise<types.ResReportForApi> {
        const res = {} as types.ResReportForApi;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post(`/report/detail/${searchType}/${type}/${idx}`, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async modifyForAnswer(type: number, param: types.ReqReportForAnswer): Promise<types.ResMember> {
        const res = {} as types.ResMember;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/report/answer/" + type, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async multiRemove(idxList: string): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/report/multi/remove", { idxList }, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async commentList(idx: number, param: types.ReqReportCommentList): Promise<types.ResReportCommentList> {
        const res = {} as types.ResReportCommentList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/report/comment/list/" + idx, param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async commentAdd(param: types.ReqReportComment): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/report/comment/add", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async commentModify(param: types.ReqReportComment): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/report/comment/modify", param, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async commentDelete(type: number, idx: number): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/report/comment/delete/" + type + "/" + idx, null, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async exportExcelForReportList(param: types.ReqReportListForExcel): Promise<any> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response: AxiosResponse<Blob> = await apiService().post("/report/excel/download", param, {
                withCredentials: false,
                responseType: "blob",
            });

            return response;
        } catch (error: any) {
            console.error(error.response);
            res = error.response.data;
        }
        return res;
    },
};
